
namespace Matrix.Indexation {
    export class FactIndexRorColumns {
        static columnsKey = 'Indexation.FactIndexRor';
    }
}